import React from "react";
import Home from "./components/Pages/Home";
import Hero from "./components/Hero";

function App() {
  return (
    <>
      <Hero>
        <h1>Employee Directory</h1>
      </Hero>
      <Home />
    </>
  );
}

export default App;
